module.exports = __webpack_public_path__ + "img/18.23ec2d35.png";